import { render, staticRenderFns } from "./AlltruePlusUpgrade.vue?vue&type=template&id=36f8e156&scoped=true&"
import script from "./AlltruePlusUpgrade.vue?vue&type=script&lang=js&"
export * from "./AlltruePlusUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./AlltruePlusUpgrade.vue?vue&type=style&index=0&id=36f8e156&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8e156",
  null
  
)

export default component.exports